import dayjs from 'dayjs';
import * as React from 'react';

import GirlsIcon from '@/components/elements/Icon/Girls';
import GradeIcon from '@/components/elements/Icon/Grade';
import TimeFrameIcon from '@/components/elements/Icon/TimeFrame';
import { RaceProgramData } from '@/components/templates/Schedule/Calendar';
import { dayjst } from '@/lib/dayjst';
import { getVelodromeByCode } from '@/lib/race';

import { Content, Note, TableData, VelodromeName } from './style';

interface TableDataProps {
  date: dayjs.Dayjs;
  day: string;
  raceProgramData: RaceProgramData;
}

const SingleraceTableData: React.FC<TableDataProps> = React.memo(
  ({ date, day, raceProgramData }) => {
    const hasNoBorder =
      dayjst(day).isSame(date.startOf('month')) ||
      (Boolean(raceProgramData.gradeName) && !raceProgramData.isFirstDay);

    const isDisplay =
      dayjst(day).isSame(date.startOf('month')) || raceProgramData.isFirstDay;

    return (
      <TableData
        hasNoBorder={hasNoBorder}
        gradeName={raceProgramData.gradeName}
        isCanceled={Boolean(raceProgramData.isCanceled)}
        isToday={dayjst(day).isSame(dayjst(), 'day')}
      >
        {raceProgramData.gradeName && isDisplay && (
          <Content>
            {raceProgramData.velodromeCode && (
              <VelodromeName>
                {getVelodromeByCode(raceProgramData.velodromeCode).name}
              </VelodromeName>
            )}
            <GradeIcon gradeName={raceProgramData.gradeName} />
            <TimeFrameIcon timeFrame={raceProgramData.timeFrame} />
            <GirlsIcon isGirls={raceProgramData.isGirls} />
            {raceProgramData.hasChariloto !== undefined &&
              !raceProgramData.hasChariloto && <Note>※1</Note>}
            {raceProgramData.hasChariloto3 !== undefined &&
              !raceProgramData.hasChariloto3 && <Note>※2</Note>}
          </Content>
        )}
      </TableData>
    );
  },
);

export default SingleraceTableData;
